import React from 'react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Heading, Button, useDisclosure, HStack } from '@chakra-ui/react'
import { FiFileText, FiDownload, FiPieChart } from 'react-icons/fi'
import { PedidoSpotProvider } from './hooks/PedidoSpotContext'
import { TabelaPedidosSpot } from './components/TabelaPedidosSpot'
import { ModalSumarioPedidosSpot } from './components/ModalSumarioPedidosSpot'
import { usePedidoSpot } from './hooks/PedidoSpotContext'

const BotoesExportacao = () => {
  const { exportarPedidosExcel, exportarPedidosPDF, excelLoading, pdfLoading } = usePedidoSpot()

  return (
    <HStack>
      <Button leftIcon={<FiDownload />} colorScheme="green" onClick={exportarPedidosExcel} isLoading={excelLoading}>
        Exportar Excel
      </Button>
      <Button leftIcon={<FiFileText />} colorScheme="red" onClick={exportarPedidosPDF} isLoading={pdfLoading}>
        Exportar PDF
      </Button>
    </HStack>
  )
}

export const PedidoSpot = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <HeadingPages name={'Pedidos SPOT'} />
      <PedidoSpotProvider>
        <Box p={5}>
          <HStack justifyContent="space-between" mb={4}>
            <Heading size="md">Gerenciamento de Pedidos SPOT</Heading>
            <HStack>
              <BotoesExportacao />
              <Button leftIcon={<FiPieChart />} colorScheme="blue" onClick={onOpen}>
                Sumário de Pedidos
              </Button>
            </HStack>
          </HStack>

          <TabelaPedidosSpot />
          <ModalSumarioPedidosSpot isOpen={isOpen} onClose={onClose} />
        </Box>
      </PedidoSpotProvider>
    </>
  )
}
